/* eslint-disable import/no-named-as-default */
import React from "react";
import PropTypes from "prop-types";
import Communication from "./RatingSteps/Communication";
import QualityOfSubmission from "./RatingSteps/QualityOfSubmission";
import SpeedOfResponse from "./RatingSteps/SpeedOfResponse";
import Professionalism from "./RatingSteps/Professionalism";
import Message from "./RatingSteps/Message";

const RatingSteps = ({
  setRating,
  reviewStep,
  step1Rating,
  step2Rating,
  step3Rating,
  step4Rating,
  setReviewMessage,
  reviewMessage,
}) => {
  let currentStep;

  switch (reviewStep) {
    case 2:
      currentStep = (
        <QualityOfSubmission setRating={setRating} rating={step2Rating} />
      );
      break;
    case 3:
      currentStep = (
        <SpeedOfResponse setRating={setRating} rating={step3Rating} />
      );
      break;
    case 4:
      currentStep = (
        <Professionalism setRating={setRating} rating={step4Rating} />
      );
      break;
    case 5:
      currentStep = (
        <Message
          setReviewMessage={setReviewMessage}
          reviewMessage={reviewMessage}
        />
      );
      break;
    default:
      currentStep = (
        <Communication setRating={setRating} rating={step1Rating} />
      );
      break;
  }
  return currentStep;
};

RatingSteps.propTypes = {
  setRating: PropTypes.func.isRequired,
  reviewStep: PropTypes.number.isRequired,
  step1Rating: PropTypes.number,
  step2Rating: PropTypes.number,
  step3Rating: PropTypes.number,
  step4Rating: PropTypes.number,
  setReviewMessage: PropTypes.func.isRequired,
  reviewMessage: PropTypes.string.isRequired,
};

RatingSteps.defaultProps = {
  step1Rating: PropTypes.isNull,
  step2Rating: PropTypes.isNull,
  step3Rating: PropTypes.isNull,
  step4Rating: PropTypes.isNull,
};

export default RatingSteps;
